module.exports = __webpack_public_path__ + "img/index_active.021285e0.png";